<template>
  <div class="cashcreation">
    <div class="header-text"
         :style="{ width: ElementHeight }">
      <h1 class="header-title">积分商城商品管理—创建（券包）</h1>
      <div class="buttom-div">
        <el-button class="push-button"
                   @click="packageJuanbao">保存</el-button>
        <el-button class="push-button"
                   icon="iconfont icon-fanhui"
                   @click="clearbtn">返回</el-button>
      </div>
    </div>
    <div class="header-text1"></div>
    <div>
      <el-card shadow="never"
               class="card-center"
               style="margin-top: 10px">
        <!-- 表单 -->
        <div>
          <el-form size="small"
                   :label-position="labelPosition"
                   label-width="120px"
                   :model="ruleForm"
                   :rules="rules"
                   ref="ruleForms">
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="券包"
                              prop="coupPacketName">
                  <div class="flex-between">
                    <el-input v-model="ruleForm.coupPacketName"
                              @click.native="Juanbaobtn"
                              readonly
                              style="width:75%"></el-input>
                    <el-button style="margin-left: 10px"
                               @click="Xuanzhebtn">选择</el-button>
                    <span style="color:blue;line-height: 17px;margin-left:10px">说明：选择券包，点击券包跳转到券包详情</span>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="商品名称"
                              prop="commodityName">
                  <el-input v-model="ruleForm.commodityName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="商品详情">
                  <editor v-model="ruleForm.commDetail"
                          :min-height="192" />
                  <span style="color:blue">说明：商品详情可以输入文字、图片等内容</span>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="轮播图">
                  <div style="width: 100%">
                    <span style="color: #c9b916">说明：最多3张图片，规格：长*宽；格式：JPG，PNG；大小：xxMB</span>
                  </div>
                  <el-upload :http-request="handleImports"
                             :limit="3"
                             action="#"
                             list-type="picture-card"
                             style="margin-top: 20px">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog>
                    <img width="100%"
                         alt="" />
                  </el-dialog>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label="券包的券库信息">
                  <el-table size="mini"
                            class="table-style"
                            border
                            :row-class-name="tableRowClassName"
                            :header-cell-style="{
                      background: '#FCFBF2',
                      color: '#6C6839',
                      'text-align': 'center',
                    }"
                            :cell-style="{ 'text-align': 'center' }"
                            ref="multipleTable"
                            :data="Juanback"
                            tooltip-effect="dark">
                    <el-table-column label
                                     width="35"
                                     type="index">
                    </el-table-column>
                    <el-table-column prop="couponsKind"
                                     label="券类型">
                      <template scope="scope">
                        {{
                          scope.row.couponsKind === 0
                            ? "现金券"
                            : "" || scope.row.couponsKind === 1
                            ? "折扣券"
                            : "" || scope.row.couponsKind === 2
                            ? "礼品券"
                            : "" || scope.row.couponsKind === 3
                            ? "异业券"
                            : ""
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="couponsName"
                                     label="券库名称">
                    </el-table-column>
                    <el-table-column prop="innerCoupName"
                                     label="券库后台名称">
                    </el-table-column>
                    <el-table-column prop="qty"
                                     label="数量"> </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="总库存"
                              prop="stockQty">
                  <el-input v-model="ruleForm.stockQty"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="最大兑换数量">
                  <el-input v-model="ruleForm.maxNum"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="兑换日期">
                  <el-row>
                    <el-col :span="11">
                      <el-form-item prop="startDate">
                        <el-date-picker type="date"
                                        placeholder="开始日期"
                                        v-model="ruleForm.startDate"
                                        style="width: 100%"
                                        value-format="yyyy-MM-dd"></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col class="line"
                            style="text-align: center"
                            :span="2">至</el-col>
                    <el-col :span="11">
                      <el-date-picker type="date"
                                      placeholder="结束日期"
                                      v-model="ruleForm.endDate"
                                      style="width: 100%"
                                      value-format="yyyy-MM-dd"></el-date-picker>
                      <span style="color:blue;">说明：结束日期为空表示长期</span>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="兑换积分"
                              prop="creditPoint">
                  <el-input v-model="ruleForm.creditPoint"
                            style="width:50%"></el-input>
                  <span style="color:blue;margin-left:8px">说明：只允许填写数字</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="限制销售等级">
                  <el-checkbox label="限制"
                               name="type"
                               v-model="myisShow"
                               @change="handleCheckAllChange"
                               :indeterminate="isIndeterminate">
                  </el-checkbox>
                  <el-checkbox-group v-model="checkedCities"
                                     @change="handValuet">
                    <div style="width: 200px; border: 1px solid #ccc">
                      <div style="margin-left: 20px">
                        <div>
                          <el-checkbox v-for="item in checkList"
                                       :key="item.levelID"
                                       :label="item.levelID">
                            {{ item.levelName_cn }}
                          </el-checkbox>
                        </div>
                      </div>
                    </div>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="置顶排序">
                  <el-checkbox-group v-model="ruleForm.top">
                    <div style="display:flex">
                      <el-checkbox label="置顶"
                                   name="type"></el-checkbox>
                      <el-input style="margin-left: 10px"
                                v-model="ruleForm.topSortIndex"></el-input>
                    </div>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="允许兑换维护店" label-width="120px">
                  <el-radio-group v-model="ruleForm.allServShop">
                    <div style="display: flex;align-items: center;">
                      <el-radio :label="true">全部门店</el-radio>
                      <el-radio :label="false">部分门店</el-radio>
                      <el-button
                        @click="outletVisible = true"
                        style="height: 35px; line-height: 10px;margin-left: 15px;"
                        :disabled="ruleForm.allServShop"
                        >选择门店</el-button
                      >
                    </div>
                  </el-radio-group>
                  <div style="padding-top: 20px;" v-if="!ruleForm.allServShop">
                    <textarea
                    style="width: 100%; margin: 0px; padding: 0px"
                    rows="4"
                    readonly
                    v-model="ruleForm.servOrgListStr"
                  ></textarea>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="核销提醒方式">
                  <el-radio-group v-model="ruleForm.pubVeriCoupMode">
                    <el-radio label="0">不提醒</el-radio>
                    <el-radio label="1">公众号模板消息</el-radio>
                    <el-radio label="2">短信消息</el-radio>
                    <el-radio label="3">公众号模板消息和短信消息 </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="券到期提醒方式">
                  <el-radio-group v-model="ruleForm.expirationMode">
                    <el-radio label="0">不提醒</el-radio>
                    <el-radio label="1">公众号模板消息</el-radio>
                    <el-radio label="2">短信消息</el-radio>
                    <el-radio label="3">公众号模板消息和短信消息 </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="提前提醒">
                  <el-input style="width: 130px"
                            v-model="ruleForm.expirationTime"></el-input>
                  &nbsp; &nbsp; 天
                </el-form-item>
              </el-col>
            </el-row>
            <el-row> </el-row>
          </el-form>
        </div>
      </el-card>
      <!-- 选择门店弹窗 -->
      <div class="outlet">
        <el-dialog
          :close-on-click-modal="false"
          width="30%"
          :visible.sync="outletVisible"
          title="选择门店"
        >
          <el-form size="mini" label-width="90px">
            <el-row
              :gutter="50"
              v-for="(item, index) in StoreSelectionList"
              :key="index"
            >
              <el-col
                :span="12"
                v-for="(myitem, myindex) in item"
                :key="myindex"
              >
                <el-tree
                  ref="tree"
                  v-if="myitem != undefined"
                  :data="[myitem]"
                  show-checkbox
                  node-key="shopID"
                  highlight-current
                  default-expand-all
                  :default-checked-keys="xuanzhong"
                  :props="defaultProps"
                >
                </el-tree>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="ComButtomStore">确 定</el-button>
            <el-button @click="outletVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
      <!-- 选择弹窗 -->
      <div class="choice">
        <el-dialog width="40%"
                   title="积分商城商品管理—创建（券包）"
                   :visible.sync="innerVisible">
          <el-form size="mini"
                   :label-position="labelPosition"
                   label-width="100px">
            <el-button icon="el-icon-search"
                       style="margin-left: 87%; margin-top: -10px; margin-bottom: 10px"
                       @click="Seachbtner">查询</el-button>
            <el-row>
              <el-col>
                <el-form-item label="券包名称">
                  <el-input style="width: 60%"
                            v-model="queryArr.coupPacketName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div style="width: 100%">
            <el-table size="mini"
                      class="table-style"
                      border
                      :row-class-name="tableRowClassName"
                      :header-cell-style="{
                background: '#FCFBF2',
                color: '#6C6839',
                'text-align': 'center',
              }"
                      :cell-style="{ 'text-align': 'center' }"
                      ref="multipleTable"
                      :data="queryList"
                      tooltip-effect="dark"
                      v-el-table-infinite-scroll="true"
                      infinite-scroll-disabled="true">
              <el-table-column label
                               width="35">
                <template slot-scope="scope">
                  <el-radio v-model="radioId"
                            :label="scope.$index"
                            @change.native="handleRadioChange(scope.row)">&nbsp;
                  </el-radio>
                </template>
              </el-table-column>
              <el-table-column prop="coupPacketName"
                               label="券名称">
              </el-table-column>
            </el-table>
          </div>
          <div slot="footer"
               class="dialog-footer">
            <el-button @click="Determine">确 定</el-button>
            <el-button @click="innerVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
  couppacketView,
  couppacketJuan,
  upperOrLowerinsert,
  customerlevelApi,
  imageupadatApi,
} from "@/api/Integralquery";
import {
  RegionApi,
} from "@/api/reportForm";
import { dateTimes } from '@/utils/auth'
export default {
  name: "centre",
  data () {
    return {
      screenWidth: "",
      ElementHeight: "0px",
      innerVisible: false,
      labelPosition: "right",

      form: {
        radio: "",
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      ruleForm: {
        allServShop:true,
        commAllowLvlList: [],
        commodityName: "", //商品名称
        commDetail: "", //商品详情
        stockQty: "", //库存数
        startDate: "", //开始时期
        endDate: "", //结束日期
        coupPacketID: "", //券库 ID
        coupPacketName: "", //券包名称
        maxNum: "", //最大兑换数量
        creditPoint: "", //兑换积分
        expirationMode: '0', //到期提醒方式
        pubVeriCoupMode: '0', //核销提醒方式
        allUser: true, //限制销售等级
        top: false, //置顶
        topSortIndex: "", //置顶序列号
        expirationTime: "", //到期提醒天数
        commKind: 2,
      },
      // 选择门店弹窗
      outletVisible: false,
      regionList: [],
      xuanzhong: [],
      StoreSelectionList: [],
      StoredataArray: [],
      StoreSelectLength: 0,
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      // 内层弹窗数据
      JuanList: [],
      checkList: [],
      isIndeterminate: false,
      checkedCities: [],
      queryList: [],
      queryArr: {
        pageSize: "50",
        pageNo: "1",
        coupPacketName: "",
        state: 0,
      },
      radioId: "",
      handleCheckValue: "",
      //劵包信息库数据存放
      Juanback: [],
      //上传时images
      coverImage: [],
      rules: {
        coupPacketName: [
          { required: true, message: '请选择劵包', trigger: 'change' },

        ],
        commodityName: [
          { required: true, message: '商品名称不能为空！', trigger: 'change' },

        ],
        stockQty: [
          { required: true, message: '请输入库存', trigger: 'blur' },

        ],
        creditPoint: [
          { required: true, message: '请输入兑换积分', trigger: 'blur' },
        ],
        startDate: [
          { required: true, message: '请输入开始时间', trigger: 'change' },
        ],
      }
    };
  },
  created () {
    this.customermethods();
  },
  computed: {
    myisShow () {
      return !this.ruleForm.allUser
    }
  },
  watch: {
    screenWidth () {
      this.ElementHeight =
        document.querySelector(".cashcreation").offsetWidth + "px";
    },
  },
  mounted () {
    this.getELmentHeight()
    this.regionSelectList();
  },
  methods: {
    ComButtomStore() {
      this.ruleForm.servOrgList = [];
      this.ruleForm.servOrgListStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          this.ruleForm.servOrgList.push(
            ...this.StoredataArray[index].chlidren
          );
        } else {
          this.ruleForm.servOrgList.push(...item);
        }
      }
      this.ruleForm.servOrgList.forEach((item) => {
        this.ruleForm.servOrgListStr += `${item.lable}\n`;
      });
      this.xuanzhong = [];
      for (let i = 0; i < this.ruleForm.servOrgList.length; i++) {
        this.xuanzhong.push({
          shopID:this.ruleForm.servOrgList[i].id
        });
      }
      this.outletVisible = false;
      console.log(this.ruleForm)
    },
    regionSelectList() {
      RegionApi({ regionID: "" }).then((res) => {
        if (res.success) {
          this.regionList.push({
            id: "",
            lable: "全部区域",
          });
          this.regionList.push(...res.data);

          let arr1 = [],
            arr2 = [];
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.shopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getELmentHeight () {
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName ({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    clearbtn () {
      this.$router.go(-1);
    },
    handleCheckAllChange (val) {
      let arr = [];
      this.checkedCities = val ? arr : [];
      this.checkList.forEach((item) => {
        arr.push(item.levelID);
      });
      this.isIndeterminate = false;
      this.ruleForm.allUser = !val;
    },
    handValuet (val) {
      let checkedCount = val.length;

      if (val.length !== 0) {
        this.ruleForm.allUser = false
      } else {
        this.ruleForm.allUser = true
      }
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.checkList.length;
    },
    async couppacketViewCool () {
      await couppacketView({
        coupPacketID: this.handleCheckValue.coupPacketID,
      }).then((res) => {
        this.Juanback = res.line;
      });
    },
    //选择按钮获取表格数据
    Xuanzhebtn () {
      this.Securitieslibrary();
      this.innerVisible = true;
    },
    //选择劵库数据请求
    async Securitieslibrary () {
      await couppacketJuan(this.queryArr).then((res) => {
        this.queryList = res.data.list;
      });
    },
    handleRadioChange (val) {
      this.handleCheckValue = val;
      // console.log(this.handleCheckValue);
    },
    Determine () {
      this.ruleForm.coupPacketName = this.handleCheckValue.coupPacketName;
      this.ruleForm.commodityName = this.handleCheckValue.coupPacketName;
      this.ruleForm.coupPacketID = this.handleCheckValue.coupPacketID;
      this.radioId = ''
      this.couppacketViewCool();
      this.innerVisible = false;
    },
    Seachbtner () {
      this.Securitieslibrary();
    },
    //创建保存功能
    packageJuanbao () {
      this.$refs.ruleForms.validate((valid) => {
        if (valid) {
          let arr = [];
          this.checkList.forEach((item) => {
            arr.push(item.levelID);
          });
          this.ruleForm.commAllowLvlList = [];
          // this.ruleForm.allUser = arr.length === this.checkedCities.length;
          for (let i = 0; i < this.checkedCities.length; i++) {
            const item = this.checkedCities[i];
            if (this.ruleForm.allUser === true) {
              console.log("----");
            } else {
              this.ruleForm.commAllowLvlList.push({ levelID: item });
            }
          }
          let querFint = {
            commAllowLvlList: this.ruleForm.commAllowLvlList,
            commodityName: this.ruleForm.commodityName, //商品名称
            commDetail: this.ruleForm.commDetail, //商品详情
            stockQty: this.ruleForm.stockQty, //库存数
            startDate: dateTimes(this.ruleForm.startDate), //开始时期
            endDate: dateTimes(this.ruleForm.endDate), //结束日期
            coupPacketID: this.ruleForm.coupPacketID, //券包ID
            coupPacketName: this.ruleForm.coupPacketName, //券包名称
            maxNum: this.ruleForm.maxNum, //最大兑换数量
            creditPoint: this.ruleForm.creditPoint, //兑换积分
            expirationMode: this.ruleForm.expirationMode, //到期提醒方式
            pubVeriCoupMode: this.ruleForm.pubVeriCoupMode, //核销提醒方式
            allUser: this.ruleForm.allUser, //限制销售等级
            top: this.ruleForm.top, //置顶
            topSortIndex: this.ruleForm.topSortIndex, //置顶序列号
            expirationTime: this.ruleForm.expirationTime, //到期提醒天数
            commKind: this.ruleForm.commKind,
            image1: this.coverImage[0],
            image2: this.coverImage[1],
            image3: this.coverImage[2],
            allServShop:this.ruleForm.allServShop,
            servOrgList:this.ruleForm.allServShop ? []:this.ruleForm.servOrgList.map(item => {return {shopID:item.shopID}})
          };
          upperOrLowerinsert(querFint).then((res) => {
            if (res.message === "success") {
              this.$message.success("创建成功");
              this.$router.push({
                path: "/Commodity",
              });
            }
          });
        }
      })

    },
    async customermethods () {
      await customerlevelApi().then((res) => {
        this.checkList = res.data;
      });
    },
    Juanbaobtn () {
      if (this.ruleForm.coupPacketName == '') {
        console.log('111');
      } else {
        this.$router.push({
          path: "/VoucherSee",
          query: {
            mobile: this.handleCheckValue.coupPacketID,
          },
        });
      }

    },
    handleImports (file) {
      const params = new FormData();
      params.append("file", file.file);
      imageupadatApi(params)
        .then((res) => {
          if (res.data) {
            this.coverImage.push(res.data);
          }
          this.$message.success("上传成功！");
        })
        .catch(() => {
          this.$message.error("上传失败!");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
/deep/.el-dialog__footer {
  height: 60px;
  text-align: center;
  background-color: #f2f2f2;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
#vouchercreate {
  height: auto;
  padding-bottom: 50px;
}
.header-text {
  position: fixed;
  z-index: 88;
  margin-top: -1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  background-color: #f3f5f7;
  height: 4.5rem;
  color: #76734f;
  padding-bottom: 5px;
}
.card-pagination {
  height: 50px;
}

// input框的圆角取消
/deep/input {
  border-radius: 0 !important;
}
//改变Upload 上传组件大小
/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
}
/deep/ .el-upload {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
}

::v-deep {
  // 表格隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }

  .choice {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 12px !important;
    }

    /* Dialog对话框 公共部分样式 End*/

    .el-tabs__item {
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-button:hover {
      background-color: #b6b388;
    }
    .el-form-item__content {
      line-height: 0px;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .flex-between input.el-input__inner:nth-child(1) {
    text-decoration: underline;
    color: blue;
  }
}
.cashcreation {
  margin-bottom: 100px;
}
.header-title {
  min-width: 250px;
  line-height: 50px;
  height: 50px;
}
.header-text1 {
  height: 3.5rem;
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: flex-end;
  width: 250px;
  height: 50px;
  align-content: center;
}
.push-button {
  width: 100px;
  color: #a19b59;
}
</style>
